import {Preferences} from '@capacitor/preferences';
import {type StorageLikeAsync} from '@vueuse/core';

const requestsInProgress = new Set<Promise<unknown>>();

async function trackRequest<T>(promise: Promise<T>): Promise<T> {
    requestsInProgress.add(promise);
    try {
        return await promise;
    } finally {
        requestsInProgress.delete(promise);
    }
}

export const capacitorStorage: StorageLikeAsync = {
    async getItem(key) {
        return trackRequest(Preferences.get({key}).then(({value}) => value));
    },
    async setItem(key, value) {
        return trackRequest(Preferences.set({key, value}));
    },
    async removeItem(key) {
        return trackRequest(Preferences.remove({key}));
    },
};

export async function allRequestsSettled() {
    if (requestsInProgress.size === 0) {
        return;
    }
    await Promise.allSettled([...requestsInProgress]);
}
